module.exports = __webpack_public_path__ + "img/share.57743505.png";